import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'

import AddPhotosDialog from './AddPhotosDialog'
import PhotoItem from './PhotoItem'
import addPhotoIcon from 'resources/add_photo_icon.png'

export const PHOTO_ITEM_SIZE = 74

const AddPhotosButton = ({ width, height, onClick }) => {
  return (
    <FlatButton style={styles.button(width, height)} onTouchTap={onClick}>
      <div style={styles.content}>
        <img src={addPhotoIcon} width={26} height={21} />
        <div style={styles.addPhotosText}>Add Photos</div>
      </div>
    </FlatButton>
  )
}

AddPhotosButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
}

export default class InvoicePhotos extends React.Component {

  static propTypes = {
    invoiceEditor: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      showAddPhotosDialog: false
    }
  }

  handleAddPhotosButtonClicked = () => {
    this.setState({
      showAddPhotosDialog: true
    })
  }

  handleAddPhotosDialogCloseRequested = () => {
    this.setState({
      showAddPhotosDialog: false
    })
  }

  handleAddPhotosDialogSelection = selection => {
    this.props.invoiceEditor.addPhotos(selection)
    this.setState({
      showAddPhotosDialog: false
    })
  }

  render() {
    const list = this.props.invoiceEditor.isLoadingPhotos()
      ? <div style={styles.progress}>
        <CircularProgress thickness={2} />
      </div>
      : this.props.invoiceEditor.getPhotos().map((photo, index) =>
        <PhotoItem
          key={index}
          selectable={false}
          photo={photo}
          sample='small'
          style={index && styles.photosDivider || {}}/>)
    return (
      <div style={styles.container}>
        <div style={styles.label}>Photos</div>
        <div style={styles.list}>
          <AddPhotosButton
            key={'Add'}
            onClick={this.handleAddPhotosButtonClicked}
            width={PHOTO_ITEM_SIZE}
            height={PHOTO_ITEM_SIZE} />
          { list }
        </div>
        <AddPhotosDialog
          open={this.state.showAddPhotosDialog}
          invoiceEditor={this.props.invoiceEditor}
          onCloseRequested={this.handleAddPhotosDialogCloseRequested}
          onPhotosSelected={this.handleAddPhotosDialogSelection} />
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 36
  },
  input: {
    borderRadius: 4,
    border: 'solid 1px #e6e8ed',
    color: '#4a4a4a',
    padding: '7px 11px 7px 11px',
    fontSize: 14
  },
  textArea: {
    resize: 'none'
  },
  label: {
    fontSize: 14,
    marginBottom: 18,
    color: '#494949'
  },
  button: (width, height) => ({
    width: width,
    height: height,
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.14)',
    marginRight: 14
  }),
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  addPhotosText: {
    color: '#757575',
    fontSize: 13
  },
  list: {
    display: 'flex',
    flexDirection: 'row'
  },
  photosDivider: {
    marginLeft: 14
  },
  progress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 22
  }
}



// WEBPACK FOOTER //
// ./src/billing/invoices/modules/photos/InvoicePhotos.js